export default __webpack_public_path__ + "static/media/82.70df1a3a.jpg";